var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 10C21.4 10 16 15.4 16 22C16 28.6 21.4 34 28 34C34.6 34 40 28.6 40 22C40 15.4 34.6 10 28 10ZM28 30C23.6 30 20 26.4 20 22C20 17.6 23.6 14 28 14C32.4 14 36 17.6 36 22C36 26.4 32.4 30 28 30Z",
    fill: "#00b26b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5 0 0 12.5 0 28C0 35.6 3.1 42.6 8 47.6C9.2 48.8 10.5 49.9 12 50.9C16.5 54.1 22 55.9 28 55.9C34 55.9 39.5 54 44 50.9C45.4 49.9 46.7 48.8 48 47.6C53 42.5 56 35.6 56 28C56 12.5 43.5 0 28 0ZM28 52C22 52 16.6 49.8 12.4 46.2C13.5 42.6 16.8 40 20.7 40H35.4C39.3 40 42.6 42.6 43.7 46.2C39.4 49.8 34 52 28 52ZM46.7 43C44.6 38.8 40.3 36 35.4 36H20.7C15.7 36 11.4 38.9 9.4 43C6 38.9 4 33.7 4 28C4 14.8 14.8 4 28 4C41.2 4 52 14.8 52 28C52 33.7 50 38.9 46.7 43Z",
    fill: "#00b26b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f964c7b147cc9f117f8c70c5e4491edf.svg";
export { ForwardRef as ReactComponent };